import { render, staticRenderFns } from "./EditWidget.vue?vue&type=template&id=8a329fdc&scoped=true&"
import script from "./EditWidget.vue?vue&type=script&lang=ts&"
export * from "./EditWidget.vue?vue&type=script&lang=ts&"
import style0 from "./EditWidget.vue?vue&type=style&index=0&id=8a329fdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a329fdc",
  null
  
)

export default component.exports